import { render } from "./MesasList.vue?vue&type=template&id=6fe1e7f1&scoped=true"
import script from "./MesasList.vue?vue&type=script&lang=js"
export * from "./MesasList.vue?vue&type=script&lang=js"

import "./MesasList.vue?vue&type=style&index=0&id=6fe1e7f1&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe1e7f1"]])

export default __exports__